import React from "react";
import Img from "gatsby-image";
var BookTemplate = function BookTemplate(props) {
    var _book$cover;
    var book = props.book, _props$authors = props.authors, authors = _props$authors === void 0 ? [] : _props$authors;
    var image = book !== null && book !== void 0 && (_book$cover = book.cover) !== null && _book$cover !== void 0 && _book$cover.fixed ? /*#__PURE__*/ React.createElement(Img, {
        fixed: book.cover.fixed,
        key: "current-author-index",
        className: "mb-2",
        style: {
            width: "100px",
            height: "150px"
        }
    }) : null;
    var description = book ? /*#__PURE__*/ React.createElement("p", {
        className: "text-sm break-words mb-4",
        style: {
            hyphens: "auto"
        }
    }, /*#__PURE__*/ React.createElement("strong", null, book.title)) : null;
    return /*#__PURE__*/ React.createElement("a", {
        href: (book === null || book === void 0 ? void 0 : book.link) || "#",
        target: book !== null && book !== void 0 && book.link ? "_blank" : ""
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col pr-2 w-32",
        style: {
            minWidth: "min-content"
        }
    }, image, authors.length ? authors.map(function (a, i) {
        return /*#__PURE__*/ React.createElement("p", {
            key: i
        }, a);
    }) : null, description));
};
export default BookTemplate;
